import styled from 'styled-components';

const Wrapper = styled.div`
  margin-left: -15px;

  .tradingview-widget-copyright {
    display: none;
  }

  &:has(iframe) {
    .tradingview-widget-copyright {
      display: block;
      .blue-text {
        display: block;
        margin-left: 15px;
        text-align: left;
      }
    }
  }
`;

export default Wrapper;
